import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Heading,
  NavbarContent,
  Box,
  NavbarCollapse,
  NavbarItem,
  NavbarToggle,
} from "legion-ui";

const NavigationMenu = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: "flex", alignItem: "center" }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <NavbarItem href="/home">Menu 1</NavbarItem>
          <NavbarItem isActive href="/profile">
            Menu 1
          </NavbarItem>
          <NavbarItem>Menu 1</NavbarItem>
          <NavbarItem>Menu 1</NavbarItem>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <NavbarItem href="/home">Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
        <Box>
          <NavbarItem>Menu 1</NavbarItem>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};

export default NavigationMenu;
